import { useAppDispatch } from 'app/hooks';
import { FilterBarDropdownProps } from 'common/components/filter/FilterBar.types';
import { GlobalRole } from 'common/types/Entities';
import { statusDropdownConfiguration } from 'common/utils/StatusDropdownFilterConfiguration';

import { checkGlobalRoleFilter, checkStatusFilter } from './tenantUserMembershipSlice';

export const useDropDownFiltersConfiguration = (
    globalRoles: GlobalRole[]
): FilterBarDropdownProps[] => {
    const dispatch = useAppDispatch();

    const dropdownsConfig = [
        {
            dropdownInfo: {
                id: 'globalRoles',
                label: 'Global Roles',
                searchOptions: ['option1', 'option2'],
                checkBoxes: globalRoles.map(role => ({ label: role.name, id: role.id })),
                isSearch: false,
                hasClear: false,
            },
            dropdownReducer: (label: string) => {
                dispatch(checkGlobalRoleFilter(label));
            }
        },
        {
            dropdownInfo: statusDropdownConfiguration,
            dropdownReducer: (label: string) => {
                dispatch(checkStatusFilter(label));
            },
        },
    ];

    return dropdownsConfig;
};
